// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3WtP5","messages":"Chat_messages__3lFDm","dateDivider":"Chat_dateDivider__3tgWy"};